import formTemplate from "../templates/main_template.js";
import pagesTitles from "../pages_titles.js";
import getBackTo from "../other/get_backto.js";
import validators from "../validators/validators.js";
import fieldsCheckers from "../fields_checkers/checkers.js";
import submitHandlers from "../submit_handlers/submit_handlers.js";

const { validatePassword, validateZipCode, validateFullname, validateUsernameLegacy, validateEmail, validateUsername} = validators;
const { checkAllFields, checkUserNameLegacy, checkUserName, checkEmailLegacy, checkEmail } = fieldsCheckers;
const { doLogin, doRegistration, registerSignInLegacy, resetPassword, sendResetPasswordLink } = submitHandlers;

const backto = getBackTo();

export default {
    template: formTemplate,
    data() {
        return {
            pages: pagesTitles,
            userData: {},
            errorData: {
                fullName: null,
                username: null,
                email: null,
                password: null,
                confirmPassword: null
            },
            checkingUsername: false,
            loading: false,
            errorMessage: '',
            carrotOpened: false,
            dataInput: null,
            usernameGeneratedOnce: false,
            trueleaf: false,
            mailingListCheck: "1",
            userStatus: false,
            loginLink: "/login/" + backto,
            registerLink: "/register/" + backto,
            fullName: "",
            startButtonLabel: ajax_var.is_affiliate ? 'Go to checkout' : 'CREATE YOUR GARDEN & GET SOCIAL',
            startButtonLink: ajax_var.gs_shop_subscriptions_url,
            is_affiliate: ajax_var.is_affiliate
        }
    },

    props: ['current'],
    watch: {
        current: function (newVal, oldVal) {
            this.$nextTick(() => {
                if (newVal == "register" || newVal == "login") {
                    this.userData = {};
                    this.errorMessage = '';
                    this.dataInput = "";

                }
                if (newVal == "register" || newVal == "login" || newVal == "password") {
                    this.initFloatingLabel();
                    this.checkFieldsStatus();
                }
                this.dataInput = document.querySelector('.dataInput');
                console.log(this.dataInput);
                if (this.dataInput) {
                    //this.initFloatingLabel();
                    this.dataInput.focus();
                }
            });
        },
        userStatus: function (newVal, oldVal) {
            this.$nextTick(() => {
                if (newVal) {
                    this.startButtonLabel = 'Create your garden';
                    this.startButtonLink = ajax_var.hortisketch_domain + 'design'
                }
            });
        }
    },
    mounted() {
        if (this.inIframe()) {
            document.querySelector('.trueleafgs').style.display = 'block';
            this.trueleaf = true;
        }
        this.initFloatingLabel();
        this.errorMessage = '';
        this.dataInput = document.querySelector('.dataInput');

        if ((this.pages[this.current].prev && !this.userData[this.pages[this.current].prev] && this.current != 'welcome' && this.current != 'register' && this.current != 'login') ||
            this.current == 'reset') {
            this.$router.push('/');
        }
        if (ajax_var.current_user == 0 && (this.current == 'welcome' || this.current == 'video')) {
            //if(ajax_var.current_user == 0 && (this.current == 'welcome')){
            this.$router.push('/login/');
        }
        if (this.current == 'reset_password' && (!ajax_var.r_id || !ajax_var.r_key)) {
            this.$router.push('/login/');
        }
        if (this.current != 'video' && this.current != 'reset' && this.current != 'welcome') {
            this.dataInput.focus();
        }

        this.$root.$on('gs_login_signup:route_changed', ({to, from}) => {
            this.errorMessage = ''; // Clear error when route changes
        });
    },
    methods: {
        checkFieldsStatus() {
            this.$nextTick(() => {
                document.querySelectorAll('input').forEach((input) => {
                    if (input.value != "" || input.hasFocus) {
                        input.parentNode.classList.add('focused');
                    }
                });
            });
        },
        inIframe() {
            try {
                return window.self !== window.top;
            } catch (e) {
                return true;
            }
        },
        initFloatingLabel() {
            document.querySelectorAll('label').forEach((label) => {
                label.addEventListener('click', (e) => {
                    if (!e.target.parentNode.classList.contains('focused')) {
                        e.target.parentNode.querySelector('input').focus();
                    } else {
                        e.preventDefault();
                    }
                });
                label.addEventListener('mousedown', (e) => {
                    e.preventDefault();
                });
            });
            document.querySelectorAll('input').forEach((input) => {
                input.parentNode.classList.remove('focused');
                if (input.value != "") {
                    input.parentNode.classList.add('focused');
                }
                input.addEventListener('focus', (e) => {
                    e.target.parentNode.classList.add('focused');
                });

                input.addEventListener('blur', (e) => {
                    let inputValue = e.target.value;
                    if (inputValue === "") {
                        e.target.classList.remove('filled');
                        e.target.parentNode.classList.remove('focused');
                    } else {
                        e.target.classList.add('filled');
                    }
                });
            });
        },
        goToVideo() {
            this.carrotOpened = false;
            this.$router.push('/video/');
        },
        async generateUsername() {
            if (this.fullName && !this.usernameGeneratedOnce) {
                this.checkingUsername = true;
                this.userData[this.current] = this.$refs;
                let username = this.fullName.toLowerCase().trim();

                username = username.replace(/[^a-z0-9_]/g, '_');
                username = username.replace(/\s+/g, '_');

                const randomNumber = Math.floor(Math.random() * 99) + 1;
                username += randomNumber.toString().padStart(2, '0');

                while (username.length < 4) {
                    const randomNumber = Math.floor(Math.random() * 10); // Número aleatorio del 0 al 9
                    username += randomNumber;
                }

                this.userData[this.current].username.value = username;
                this.$refs.username._value = username;

                let check = false;
                let plus = 0;
                while (!check) {
                    check = await this.checkUsername(true, plus);
                    plus++;
                }

                this.checkingUsername = false;
                this.usernameGeneratedOnce = true;
                this.$nextTick(() => {
                    this.$refs.email.focus();
                });
                return;
            }
        },
        togglePassword() {
            const togglePassword = document.querySelector('#togglePassword');
            const confirmPassword = document.querySelector('.confirmPassword');
            const password = document.querySelector('.passwordInput');

            const type = password.getAttribute('type') === 'password' ? 'text' : 'password';
            password.setAttribute('type', type);
            if (confirmPassword) {
                confirmPassword.setAttribute('type', type);
            }
            togglePassword.classList.toggle('fa-eye-slash');
        },
        togglePasswordLegacy() {
            const togglePassword = document.querySelector('#togglePassword');
            const confirmPassword = document.querySelector('.confirmPassword');
            const password = this.dataInput;

            const type = password.getAttribute('type') === 'password' ? 'text' : 'password';
            password.setAttribute('type', type);
            confirmPassword.setAttribute('type', type);

            togglePassword.classList.toggle('fa-eye-slash');
        },
        saveZipVal() {
            this.userData[this.current] = this.dataInput.value;
        },
        async next(e) {
            this.initFloatingLabel();
            this.checkFieldsStatus();
            if (this.pages[this.current].next && this.current == "register") {
                this.userData[this.current] = this.$refs;

                if (checkAllFields.call(this)) {
                    doRegistration.call(this);
                }
            }

            if (this.pages[this.current].next && this.current == "login") {
                this.userData[this.current] = {
                    email: document.getElementById("login_email").value,
                    password: document.getElementById("login_password").value
                };

                if (checkAllFields.call(this)) {
                    doLogin.call(this);
                }
            }

            if (this.current == 'forgot') {
                this.userData[this.current] = this.dataInput.value;
                if (checkAllFields.call(this)) {
                    this.sendResetLink();
                }
                return;
            }

            if (this.current == 'reset_password') {
                this.userData[this.current] = this.dataInput.value;
                if (checkAllFields.call(this)) {
                    this.sendResetPassword();
                }
                return;
            }


            if (this.current != "reset_password" && this.current != "forgot" && this.current != "register" && this.current != "login") {
                if (this.dataInput) {
                    this.userData[this.current] = this.dataInput.value;
                    if (this.pages[this.current].next && checkAllFields.call(this)) {
                        this.$nextTick(() => {
                            if (this.current == 'email') {
                                this.checkEmailLegacy();
                            } else if (this.current == 'zipcode' || this.current == 'signin') {
                                if (this.current == 'zipcode') {
                                    this.userData.signin = null;
                                }

                                registerSignInLegacy.call(this);

                                return;
                            } else {
                                this.$router.push('/' + this.pages[this.current].next + '/');
                                this.dataInput.value = "";
                                this.errorMessage = "";
                            }
                        });
                    }
                } else {
                    this.$router.push('/' + this.pages[this.current].next + '/');
                    this.errorMessage = "";
                }
            }
        },
        disableInputs() {
            document.querySelector('.input-step-btn').disabled = true;
            document.querySelector('.dataInput').disabled = true;
        },
        enableInputs() {
            document.querySelector('.input-step-btn').disabled = false;
            document.querySelector('.dataInput').disabled = false;
        },
        back() {
            if (this.pages[this.current].prev) {
                this.$router.push('/' + this.pages[this.current].prev + '/');
                this.dataInput.value = "";
                this.errorMessage = "";
            }
        },
        convertRefsToObject(refs) {
            return Object.entries(refs)
                .reduce((obj, [key, value]) => {
                    obj[key] = value._value;
                    return obj;
                }, {});
        },

        async checkEmail() {
            return checkEmail.call(this);
        },

        /**
         * this method is used by Trueleaf users
         */
        async checkEmailLegacy() {
            return checkEmailLegacy.call(this);
        },

        async checkUsername(mode = false, plus = 0) {
            return checkUserName.call(this, mode, plus);
        },

        /**
         * this method is used by Trueleaf users
         */
        checkUsernameLegacy(username) {
            return checkUserNameLegacy.call(this, username);
        },

        validateUsername(username) {
            return validateUsername.call(this, username)
        },

        /**
         * this method is used by Trueleaf users
         */
        validateUsernameLegacy(username) {
            return validateUsernameLegacy.call(this, username);
        },

        validateEmail(email) {
            return validateEmail.call(this, email);
        },

        validateFullName(fullName) {
            return validateFullname.call(this, fullName)
        },

        validateZipCode(zipcode) {
            return validateZipCode.call(this, zipcode);
        },

        validatePassword(password) {
            return validatePassword.call(this, password);
        },

        async sendResetLink() {
            sendResetPasswordLink.call(this);
        },

        sendResetPassword() {
            resetPassword.call(this);
        },
    },
};
